import { CTAFunction } from "../../../api/cta/ctaFunction/CTAFunction";
import { PlayerCTAAPI } from "../../../api/cta/PlayerCTAAPI";
import { ClickableAreaConditionalCTAConfiguration } from "./ClickableAreaConditionalCTAConfiguration";

const ACTION_ID = 0;

export const clickableAreaConditionalCTAFunction: CTAFunction = (
  api: PlayerCTAAPI,
  ctaId: number,
  ctaBoard: HTMLElement,
  config: ClickableAreaConditionalCTAConfiguration,
) => {
  const clickableArea = document.createElement("div");

  if (config.conditionalParam && config.conditionalValue &&
      config.conditionalParam.toLowerCase() === config.conditionalValue.toLowerCase()) {
    clickableArea.setAttribute("class", "clickableAreaItem");
    clickableArea.style.top = `${parseInt(config.top, 10)}%`;
    clickableArea.style.bottom = `${parseInt(config.bottom, 10)}%`;
    clickableArea.style.left = `${parseInt(config.left, 10)}%`;
    clickableArea.style.right = `${parseInt(config.right, 10)}%`;
    clickableArea.style.position = "absolute";
    clickableArea.style.pointerEvents = "all";
    clickableArea.style.cursor = "pointer";
  }

  clickableArea.onclick = () => {
    if (config.scenarioElementId) {
      api.jumpToScenarioElement(config.scenarioElementId);
    } else {
      window.open(config.url, config.target ? config.target : "_blank");
    }
    api.onCTAAction(ctaId, ACTION_ID);
  };

  const container = ctaBoard.querySelector("[data-role='container']");
  container.appendChild(clickableArea);

  return {
    action: () => {},
  };
};
